<template>
  <!-- <div class="how-it-works-steps-area ptb-50">



    <div class="container">
      <div class="section-title text-center mb-5">
        <h2>HOW IT WORKS - 6 SIMPLE STEPS</h2>
      </div>
      
      <div class="steps-container">
        <div class="steps-row">
                            <div class="step-card" v-for="(step, index) in steps" :key="index">
                    <div class="step-top-section">
                      <div class="step-icon" :class="`step-${index + 1}`">
                        <i :class="step.icon"></i>
                      </div>
                      <h3>{{ step.title }}</h3>
                    </div>
                    <div class="step-bottom-section">
                      <p>{{ step.description }}</p>
                    </div>
                  </div>
        </div>
        

      </div>
    </div>
  </div> -->

  <section class="timeline">
    <div class="how-it-works-steps-area">
      
    <h2>HOW IT WORKS - 6 SIMPLE STEPS</h2>
    <div class="timeline-container">
      <!-- Timeline item -->
      <div class="timeline-item">
        <div class="circle circle-one"> 
          <img src="../../assets/work-icon/Select Project.png" alt=" Select Project"> 
        </div>
        <div class="content">
          <h3>Select Project</h3>
          <p>Choose a pre-built software project that fits your business needs.</p>
        </div>
      </div>

      <div class="timeline-item">
        <div class="circle circle-two">
          <img src="../../assets/work-icon/Book Demo.png" alt="Book Demo">
        </div>
        <div class="content">
          <h3>Book Demo</h3>
          <p>Schedule a live walkthrough to explore features and functionality.</p>
        </div>
      </div>

      <div class="timeline-item">
        <div class="circle circle-three">
            <img src="../../assets/work-icon/Request Changes.png" alt="Request Changes">
        </div>
        <div class="content">
          <h3>Request Changes</h3>
          <p>Discuss optional customizations, branding, or integrations.</p>
        </div>
      </div>

      <div class="timeline-item">
        <div class="circle circle-four">
           <img src="../../assets/work-icon/Confirm Order.png" alt="Request Changes">
        </div>
        <div class="content">
          <h3>Confirm Order</h3>
          <p>Approve the project and make a secure one-time payment.</p>
        </div>
      </div>

      <div class="timeline-item">
        <div class="circle circle-five">
     <img src="../../assets/work-icon/Receive Assets.png" alt="Receive Assets">

        </div>
        <div class="content">
          <h3>Receive Assets</h3>
          <p>Access source code, docs, and setup files instantly and easily..</p>
        </div>
      </div>

      <div class="timeline-item">
        <div class="circle circle-six">
           <img src="../../assets/work-icon/Launch Fast.png" alt="Launch Fast">
        </div>
        <div class="content">
          <h3>Launch Fast</h3>
          <p>Deploy quickly with optional support or upgrade plans.</p>
        </div>
      </div>
    </div>
  </div>
 </section>
</template>



<script>
export default {
  name: 'HowItWorksSteps',
  data() {
    return {
      steps: [
        {
          icon: 'ri-lightbulb-line',
          title: 'Select Project',
          description: 'Choose a pre-built software project that fits your business needs.'
        },
        {
          icon: 'ri-calendar-check-line',
          title: 'Book Demo',
          description: 'Schedule a live walkthrough to explore features and functionality.'
        },
        {
          icon: 'ri-settings-3-line',
          title: 'Request Changes',
          description: 'Discuss optional customizations, branding, or integrations.'
        },
        {
          icon: 'ri-check-double-line',
          title: 'Confirm Order',
          description: 'Approve the project and make a secure one-time payment.'
        },
        {
          icon: 'ri-download-cloud-line',
          title: 'Receive Assets',
          description: 'Instantly get access to source code, documentation, and setup files.'
        },
        {
          icon: 'ri-rocket-line',
          title: 'Launch Fast',
          description: 'Deploy quickly with optional support or upgrade plans.'
        }
      ]
    }
  }
}
</script>

<style>
.how-it-works-steps-area {
  background: transparent;
  position: relative;
  overflow: hidden;
  font-family: var(--fontFamily);

}

.section-title h2 {
  font-size: 36px;
  font-weight: 700;
  color: var(--blackColor);
  margin-bottom: 0;
  text-align: center;
  font-family: var(--fontFamily);
}

.steps-container {
  position: relative;
  padding-bottom: 30px;
}

.steps-row {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 20px;
  margin-bottom: 30px;
  flex-wrap: wrap;
}

.step-card {
 flex: 0 0 280px;
    position: relative;
    background: #fff;
    border-radius: 20px 20px 7px 7px;
    overflow: hidden;
    transition: all 0.3s ease;
    cursor: pointer;
    height: 220px;
    display: flex;
    flex-direction: column;
    width: 280px;
    box-shadow: rgba(0, 0, 0, 0.45) 0px 25px 20px -22px;
    border: 0.2px solid #00000030;
}

.step-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0,0,0,0.15);
}

.step-top-section {
  background: linear-gradient(279.99deg, #e3ccf9 -1.19%, #ffc9dd 50.96%, #ffd5b2 99.95%);
  padding: 20px 15px 15px;
  text-align: center;
  position: relative;
  flex: 0 0 auto;
  border-radius: 20px 20px 0 0;
}

.step-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 8px;
  color: #fff;
  font-size: 24px;
  transition: transform 0.3s ease;
  box-shadow: 0 6px 20px rgba(0,0,0,0.2);
}

.step-card:hover .step-icon {
  transform: scale(1.1);
}

/* Step 1 - Purple */
.step-1 {
  background: #9c27b0;
}

/* Step 2 - Dark Red */
.step-2 {
  background: #d32f2f;
}

/* Step 3 - Orange */
.step-3 {
  background: #ff9800;
}

/* Step 4 - Dark Orange */
.step-4 {
  background: #ff5722;
}

/* Step 5 - Teal */
.step-5 {
  background: #009688;
}

/* Step 6 - Dark Teal */
.step-6 {
  background: #ed2775;
}

.step-top-section h3 {
  font-size: 18px;
  font-weight: 700;
  color: var(--blackColor);
  margin: 0;
  line-height: 1.2;
  font-family: var(--fontFamily);
}

.step-bottom-section {
  background: #e4e4e421;
  padding: 12px 15px 15px;
  text-align: center;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-family: var(--fontFamily);
}

.step-bottom-section p {
  font-size: 14px;
  color: #000;
  line-height: 1.4;
  margin: 0;
  opacity: 0.9;
  transition: all 0.3s ease;
  font-family: var(--fontFamily);
  text-align: center;
}

.step-card:hover .step-bottom-section p {
  opacity: 1;
  color: var(--blackColor);
}

/* Responsive Design */
@media (max-width: 1399px) {
  .step-card {
    flex: 0 0 240px;
    width: 240px;
    height: 220px;
  }
  
  .steps-row {
    gap: 15px;
  }
}

@media (max-width: 1199px) {
  .step-card {
    flex: 0 0 200px;
    width: 200px;
    height: 200px;
  }
  
  .steps-row {
    gap: 12px;
  }
  
  .step-top-section {
    padding: 20px 12px 15px;
  }
  
  .step-bottom-section {
    padding: 15px 12px 20px;
  }
  
  .step-icon {
    width: 55px;
    height: 55px;
    font-size: 22px;
  }
  
  .step-top-section h3 {
    font-size: 15px;
  }
  
  .step-bottom-section p {
    font-size: 12px;
  }
}

@media (max-width: 991px) {
  .step-card {
    flex: 0 0 180px;
    width: 180px;
    height: 180px;
  }
  
  .steps-row {
    gap: 10px;
  }
  
  .step-top-section {
    padding: 18px 10px 12px;
  }
  
  .step-bottom-section {
    padding: 12px 10px 18px;
  }
  
  .step-icon {
    width: 50px;
    height: 50px;
    font-size: 20px;
  }
  
  .step-top-section h3 {
    font-size: 14px;
  }
  
  .step-bottom-section p {
    font-size: 11px;
  }
  

}


/* new css */
/* .circle-one {
      background: #9c27b0;
}
.circle-two {
background: #009688;
}
.circle-three {
background: #ed2775;
}
.circle-four {
    background: #ff5722;
}

.circle-five {
      background: #ff9800;
}
.circle-six {
    background: #d32f2f;
} */


.how-it-works-steps-area h2 {
    text-align: center;
    padding-bottom: 50px;
}
.timeline-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  position: relative;
  gap: 40px;
}

.timeline-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 160px;
  text-align: center;
  position: relative;
}

.circle {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  color: #fff;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
}

.content h3 {
  font-size: 16px;
  margin: 0 0 10px;
}

.content p {
  font-size: 13px;
}

/* Timeline horizontal line */
.timeline-container::before {
  content: '';
  position: absolute;
  top: 30px;
  left: 5%;
  right: 5%;
  height: 4px;
    background: linear-gradient(279.99deg, #9F5FF1 -1.19%, #FF54B0 50.99%, #FF9F5A 100%);
  z-index: -1;
}

/* Responsive layout */
@media (max-width: 768px) {
  .timeline-container {
    flex-direction: column;
    align-items: center;
  }

  .timeline-container::before {
    display: none;
  }

  .timeline-item {
    width: 90%;
    margin-bottom: 30px;
  }
}

@media (max-width: 767px) {
.content p {
    padding: 0 20px;
    text-align: center;
}
.timeline-item {
    width: 75%;
}
.timeline-container {
   gap: 0px;
}
  
.how-it-works-steps-area h2 {
    padding-bottom: 30px;
}
  .section-title h2 {
    font-size: 28px;
  }
  
  .step-card {
    flex: 0 0 100%;
    width: 100%;
    max-width: 300px;
    height: 120px;
  }
  
  .steps-row {
    flex-direction: column;
    gap: 15px;
    align-items: center;
  }
  
  .step-top-section {
    padding: 15px 8px 10px;
  }
  
  .step-bottom-section {
    padding: 10px 8px 15px;
  }
  
  .step-icon {
    width: 45px;
    height: 45px;
    font-size: 18px;
  }
  
  .step-top-section h3 {
    font-size: 13px;
  }
  
  .step-bottom-section p {
    font-size: 10px;
    line-height: 1.3;
  }
  


}

@media (max-width: 575px) {
  .section-title h2 {
    font-size: 24px;
  }
  
  .step-card {
    flex: 0 0 100%;
    width: 100%;
    max-width: 280px;
    height: 110px;
  }
  
  .steps-row {
    flex-direction: column;
    gap: 12px;
    align-items: center;
  }
  
  .step-top-section {
    padding: 12px 6px 8px;
  }
  
  .step-bottom-section {
    padding: 8px 6px 12px;
  }
  
  .step-icon {
    width: 40px;
    height: 40px;
    font-size: 16px;
  }
  
  .step-top-section h3 {
    font-size: 12px;
  }
  
  .step-bottom-section p {
    font-size: 9px;
    line-height: 1.2;
  }


}

@media screen and (min-width:814px) and (max-width:1200px) {
.timeline-item {
    width: 110px;
}
.content h3{
    font-size: 12px;
}
.content p {
    font-size: 10px;
}
.timeline-container {
    gap: 20px;
}
}


@media (max-width: 600px) { 
.timeline-container::after {
    content: "";
    position: absolute;
    left: 20px;
    height: 96%;
    background: linear-gradient(279.99deg, #9F5FF1 -1.19%, #FF54B0 50.99%, #FF9F5A 100%);
    width: 6px;
    border-radius: 100px;
    top: 10px;
    overflow-y: hidden;
}
}
</style> 